// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__D0Hxc","filesListContainer":"PosDisputesFiles_filesListContainer__E3E1z","filesButton":"PosDisputesFiles_filesButton__3ZBsP"};